import React, { useState, useEffect } from 'react';
import { logEvent } from '../../utils/logger';

const Topbar = () => {
  const featureKey = 'featureDismissedKey';
  const currentFeatureVersion = 8;
  const [isVisible, setIsVisible] = useState(false);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const checkVisibility = () => {
      const dismissedVersion = parseInt(localStorage.getItem(featureKey), 10);
      if (dismissedVersion !== currentFeatureVersion) {
        logEvent('Banner Version offer Displayed');
        setIsVisible(true);
      }
    };

    if(!isActive) return

    checkVisibility();
  }, []);

  const handleDismiss = () => {
    logEvent('Topbar Dismissed Clicked');
    localStorage.setItem(featureKey, currentFeatureVersion.toString());
    setIsVisible(false);
  };

  if (!isVisible || !isActive) {
    return null;
  }

  return (
    <div className="flex justify-between items-center p-4 bg-[#E8E5F1] w-full z-40">
      <div className="flex-1 text-center">
        <p className="font-medium text-black opacity-90 text-ba text-sm md:text-lg">
          We launched a <b>full SEO Service</b> for your company or podcast! We handle everything - keyword analysis, content creation, and repurposing...
          <span className="font-bold text-[#27004F] ml-2">
            <a href="https://www.rankchase.com/full-seo-service/" target="_blank">Learn More</a>
          </span>
        </p>
      </div>
      <div>
        <button onClick={handleDismiss} className="text-xs text-[#27004F] font-bold bg-[#FD9B79] py-1 px-3 rounded">
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default Topbar;